// Lib
import React from 'react';
import useRenderListPlaceholders, { RenderListPlaceholdersReturnProps } from './useRenderListPlaceholders';

type RenderListPlaceholdersProps = { retainPreviousVisibleElements?: boolean };

/**
 * Decorator that adds list placeholder functionality to a component.
 * Keeps track of the element measurements in the list so that placeholders can be
 * used on following renders, and calculates the initial render size based on how many
 * placeholders can be rendered.
 * If retainPreviousVisibleElements is true, it will also keep track of the visibility of elements
 * on close so that the same ones will be visible when the list is opened again.
 *
 * TODO: Replace all usages of this decorator with useSelectionMarqueeList
 */
export default function <Props extends RenderListPlaceholdersProps>(
    DecoratedComponent: React.ComponentType<Props & RenderListPlaceholdersReturnProps>,
) {
    const renderListPlaceholdersDecorator = (props: Props) => {
        const renderListPlaceholdersProps = useRenderListPlaceholders(props.retainPreviousVisibleElements);
        return <DecoratedComponent {...props} {...renderListPlaceholdersProps} />;
    };

    return renderListPlaceholdersDecorator;
}
